
import { useMemo } from 'react';
import { useFirebase } from '@/context/FirebaseProvider'; // Replaced useData
import { Business } from '@/schemas/business'; // Assuming Zod type is preferred

export const useBusinessData = (businessId?: string) => {
  const { businesses } = useFirebase(); // Get businesses from FirebaseProvider
  
  // Get the business data from global context
  const business = useMemo(() => {
    if (!businessId) {
      console.log('useBusinessData: No businessId provided');
      return null;
    }
    
    console.log('useBusinessData: Looking for business with ID:', businessId);
    
    if (!businesses) {
      console.log('useBusinessData: Businesses array not available from FirebaseProvider');
      return null;
    }
    
    const foundBusiness = businesses.find(b => b.id === businessId);
    
    if (foundBusiness) {
      console.log('useBusinessData: Found business:', foundBusiness.name);
      return foundBusiness;
    }
    
    console.log('useBusinessData: Business not found with ID:', businessId);
    return null;
  }, [businesses, businessId]);

  // Log business coordinates for debugging
  useMemo(() => {
    if (business?.coordinates) {
      console.log('useBusinessData: Found business coordinates', {
        lat: business.coordinates.lat,
        lng: business.coordinates.lng,
        businessId: businessId
      });
    } else if (business) {
      console.log('useBusinessData: Business found but no coordinates available', { 
        businessId,
        businessName: business.name || business.title
      });
    } else {
      console.log('useBusinessData: No business or coordinates found for ID:', businessId);
    }
  }, [business, businessId]);

  return { business };
};
